module.exports = __webpack_public_path__ + "static/media/logo-uniodonto.f4175a29.png";